import React, { FC } from 'react';
import { Avatar, Box, Typography, useTheme } from '@mui/material';
import ReviewWrapper from '../ReviewWrapper';
import ReviewHeader from '../ReviewHeader';
import ReviewContent from '../ReviewContent';
import ReviewFooter from '../ReviewFooter';
import { IReviewNew, IReviewNewProps } from '../../../shared/interfaces/IReviewNew';
import { CommunityManagement } from '../../../shared/interfaces/ICommunityManagement';
import ReviewText from '../ReviewText';

interface Props extends IReviewNewProps {}

const FacebookReview: FC<Props> = ({
  reviewEntry,
  communityManagement,
  commentingModule,
  hideHeader,
  hideFooter,
  statusModule,
  deletionModule,
  status,
}) => {
  const theme = useTheme();

  const { name, ratingValue, profilePicture, response, reviewText, url } = reviewEntry.review;

  return (
    <ReviewWrapper
      reviewEntry={reviewEntry}
      communityManagement={communityManagement}
      commentingModule={commentingModule}
      hideHeader={hideHeader}
      hideFooter={hideFooter}
      rating={ratingValue}
      reviewLink={url}
      statusModule={statusModule}
      status={status}
      deletionModule={deletionModule}
    >
      {name && profilePicture && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: theme.palette.text.secondary,
          }}
        >
          <Avatar
            alt={name}
            src={profilePicture}
            imgProps={{ referrerPolicy: 'no-referrer' }}
            sx={{ width: 32, height: 32, fontSize: '0.85rem' }}
          >
            {name.charAt(0)}
          </Avatar>
          <Typography
            variant="body1"
            sx={{ ml: theme.spacing(1) }}
          >
            {name}
          </Typography>
        </Box>
      )}
      <ReviewText text={reviewText} />
    </ReviewWrapper>
  );
};

export default FacebookReview;
